import { render } from "./TransportTable.vue?vue&type=template&id=1ae36777&scoped=true"
import script from "./TransportTable.vue?vue&type=script&lang=js"
export * from "./TransportTable.vue?vue&type=script&lang=js"

import "./TransportTable.vue?vue&type=style&index=0&id=1ae36777&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae36777"]])

export default __exports__